import PicHolder from "assets/albion-gallery/empty.png";
import React, { useState } from "react";
import useToggle from "shared/hooks/useToggle";
import Modal from "../Modal";

export default (props) => {
  const { d = false, type } = props;
  const modal = useToggle(false);
  // const modal = useToggle(true);
  const [pic, setpic] = useState("");

  const handle = (val) => {
    setpic(val);
    modal.off();
  };
  return d ? null : (
    <React.Fragment>
      <Modal ctrl={modal} handle={handle} type={type} />
      <div onClick={() => modal.on()}>
        <img
          className="w-100"
          src={pic || PicHolder}
          style={{ objectFit: "cover" }}
        />
      </div>
    </React.Fragment>
  );
};
